export default "__VITE_ASSET__5ebdba62__"